import { Fragment as _Fragment, jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useFlow } from "../../context/FlowContext";
import { useI18N } from '../../context/I18NContext';
import { useNavigate } from 'react-router-dom';
import { normalizeSlug } from '../../../../helpers/admin';
export default function Detail(props) {
    const flow = useFlow();
    const { t } = useI18N();
    const navigate = useNavigate();
    const handleClick = () => {
        var _a, _b, _c, _d;
        if ((_a = props.config) === null || _a === void 0 ? void 0 : _a.item) {
            if ((_b = props.config) === null || _b === void 0 ? void 0 : _b.toDetail) {
                navigate(`/oa_widget_detail/${props.config.item.id}/${normalizeSlug(props.config.item.name)}`);
            }
            if ((_c = props.config) === null || _c === void 0 ? void 0 : _c.toCategory) {
                navigate(`/oa_widget_category/${props.config.item.id}/${normalizeSlug(props.config.item.name)}`);
            }
        }
        if ((_d = props.config) === null || _d === void 0 ? void 0 : _d.toNext) {
            // @ts-ignore
            flow === null || flow === void 0 ? void 0 : flow.onNext();
        }
    };
    return (_jsx(_Fragment, {}));
}
